import cn from 'classnames'
import Plane from 'src/icons/plane.webp'
import Vint from 'src/icons/vint.webp'
import Сhart from 'src/icons/chart.webp'
import styles from './styles.module.scss'

interface IProps {
    isStopped: boolean
}

const AirPlane = ({ isStopped }: IProps) => (
    <div
        className={cn(styles.container, {
            [styles.hidden]: isStopped,
        })}
    >
        <div className={styles.wrapper}>
            <div
                className={cn(styles.mask, {
                    [styles.stop_mask]: isStopped,
                })}
            >
                <img src={Сhart} alt="Сhart" className={styles.chart} />
            </div>
        </div>
        <div
            className={cn(styles.plane_wrapper, {
                [styles.stop_plane]: isStopped,
            })}
        >
            <img src={Plane} alt="Plane" className={styles.plane} />
            <img
                src={Vint}
                alt="Vint"
                className={cn(styles.vint, {
                    [styles.stop_plane]: isStopped,
                })}
            />
        </div>
    </div>
)

export default AirPlane
